"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATETIME_OUTPUT_FORMAT = exports.DATE_OUTPUT_FORMAT = exports.DATETIME_FORMAT = exports.TIME_FORMAT = exports.DATE_FORMAT = void 0;
exports.DATE_FORMAT = 'DD.MM.YYYY';
exports.TIME_FORMAT = 'HH:mm';
exports.DATETIME_FORMAT = 'DD.MM.YYYY HH:mm';
exports.DATE_OUTPUT_FORMAT = 'YYYY-MM-DD';
exports.DATETIME_OUTPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
//# sourceMappingURL=dateTimeFormat.js.map